export default __webpack_public_path__ + "static/media/44t.720d309a.jpg";